export const MONTE_CARLO_BENCHMARKS = [0.5, 0.75, 0.85, 0.95];

export const PROBABILITY_COLORS = [
  { range: [0, MONTE_CARLO_BENCHMARKS[0]], color: '#FF8A9D' },
  {
    range: [MONTE_CARLO_BENCHMARKS[0], MONTE_CARLO_BENCHMARKS[1]],
    color: '#FFCB80'
  },
  {
    range: [MONTE_CARLO_BENCHMARKS[1], MONTE_CARLO_BENCHMARKS[2]],
    color: '#A3E4D7'
  },
  {
    range: [MONTE_CARLO_BENCHMARKS[2], MONTE_CARLO_BENCHMARKS[3]],
    color: '#58D68D'
  },
  { range: [MONTE_CARLO_BENCHMARKS[3], 1], color: '#009317' }
];

export const getColorByProbability = probability => {
  for (const { color, range } of PROBABILITY_COLORS) {
    if (probability >= range[0] && probability <= range[1]) {
      return color;
    }
  }
};
